import React from 'react';
import { useListenContext } from '../contexts/ListenContext';
import { Button } from './ui/button';
import { Check, X, AlertCircle } from 'lucide-react';

const ApprovalPanel = () => {
  const { pendingApproval, dismissApproval, approveAction } = useListenContext();

  if (!pendingApproval) return null;

  return (
    <div
      className="fixed top-4 right-4 z-[200] w-96 bg-white rounded-xl shadow-2xl border border-amber-200 overflow-hidden animate-in slide-in-from-top-5 duration-300"
      data-testid="approval-panel"
    >
      <div className="bg-amber-50 px-4 py-2.5 border-b border-amber-100 flex items-center gap-2">
        <AlertCircle className="w-4 h-4 text-amber-600" />
        <span className="text-sm font-semibold text-amber-800">Action Needs Approval</span>
        <button onClick={dismissApproval} className="ml-auto p-1 hover:bg-amber-100 rounded">
          <X className="w-3.5 h-3.5 text-amber-600" />
        </button>
      </div>
      <div className="p-4 space-y-3">
        <p className="text-xs text-slate-500">
          Voice command: <span className="font-medium text-slate-700">"{pendingApproval.message}"</span>
        </p>
        {pendingApproval.actions.map((action, i) => (
          <div key={i} className="bg-slate-50 rounded-lg p-3 border">
            <p className="text-sm text-slate-700 mb-2">
              {action.description || action.action || 'Execute this action?'}
            </p>
            <div className="flex gap-2">
              <Button
                size="sm"
                className="h-7 text-xs bg-emerald-600 hover:bg-emerald-700"
                onClick={() => approveAction(i)}
                data-testid={`approve-action-${i}`}
              >
                <Check className="w-3 h-3 mr-1" /> Approve
              </Button>
              <Button
                size="sm"
                variant="outline"
                className="h-7 text-xs"
                onClick={dismissApproval}
                data-testid={`dismiss-action-${i}`}
              >
                Dismiss
              </Button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ApprovalPanel;
